// register.store.ts
import { create } from 'zustand';

type RegisterState = {
  register_id?: number;
  setRegisterId: (id: string | number) => void;
  clearRegisterId: () => void;
};

export const useRegisterStore = create<RegisterState>((set) => ({
  register_id: undefined,
  setRegisterId: (id: string | number) => set({ register_id: Number(id) }),
  clearRegisterId: () => set({ register_id: undefined }),
}));
